import { inject, Injectable } from '@angular/core';
import { CreateVerificationMutation, VerificationServiceEnum, VerificationStatusEnum } from '../queries/generated';
import { map } from 'rxjs';
import { finalMap } from '../rx/final-map';

@Injectable({
  providedIn: 'root'
})
export class VerificationsService {
  private readonly createVerificationMutation = inject(CreateVerificationMutation);

  pass(sessionId: string, service: VerificationServiceEnum) {
    return this.createVerificationMutation
      .mutate({
        input: {
          sessionId,
          verification: {
            service,
            status: VerificationStatusEnum.Passed
          }
        }
      })
      .pipe(
        map(({ data }) => data.createVerification),
        finalMap('verification')
      );
  }

  fail(sessionId: string, service: VerificationServiceEnum, reason: string) {
    return this.createVerificationMutation
      .mutate({
        input: {
          sessionId,
          verification: {
            service,
            status: VerificationStatusEnum.Failed,
            reason
          }
        }
      })
      .pipe(
        map(({ data }) => data.createVerification),
        finalMap('verification')
      );
  }
}
